import type { ReactNode } from 'react';

type CompanyDetailWorkspaceProps = {
  header?: ReactNode;
  overview?: ReactNode;
  activity?: ReactNode;
  emptyState?: ReactNode;
  loading?: boolean;
};

export function CompanyDetailWorkspace({
  header,
  overview,
  activity,
  emptyState,
  loading = false,
}: CompanyDetailWorkspaceProps) {
  return (
    <section className="company-detail-workspace" aria-label="Карточка компании">
      {loading ? (
        <div className="company-detail-workspace__state" aria-busy="true">
          Загружаем карточку компании…
        </div>
      ) : !header ? (
        <div className="company-detail-workspace__state">{emptyState}</div>
      ) : (
        <>
          <header className="company-detail-workspace__header">{header}</header>
          <div className="company-detail-workspace__body">
            <div
              className="company-detail-workspace__overview"
              role="region"
              aria-label="Обзор компании"
              tabIndex={0}
            >
              {overview}
            </div>
            <div
              className="company-detail-workspace__activity"
              role="region"
              aria-label="Рабочая область компании"
              tabIndex={0}
            >
              {activity}
            </div>
          </div>
        </>
      )}
    </section>
  );
}

